module.exports = __webpack_public_path__ + "images/2b98533a6083fbf5c3d4a228ccc3dc80.svg";